<!-- eslint-disable vue/no-v-html -->
<template>
  <Transition name="filterpel-fade">
    <div v-if="isLoading" :class="[`fw-filterpel-entries-loading`, isLoading ? 'is-loading' : '']">
      <LoadingIcon />
    </div>
  </Transition>
  <div :class="[`fw-filterpel-entries-contents`, isLoading ? 'is-loading' : '']">
    <div v-if="entriesHTML" v-html="entriesHTML" />
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, useHost, getCurrentInstance, watch } from "vue";

import useStateStore from "@stores/state";
import useEntriesStore from "@stores/entries";

import LoadingIcon from '@assets/loading.svg?component';

// define stores
const stateStore = useStateStore();
const entriesStore = useEntriesStore();

// define props
const props = defineProps<{
  elemId: string
}>();

// define emits
const emit = defineEmits<{
  "pageRefresh": [html: string]
}>();

// computed
const isLoading = computed(() => stateStore.isLoading);
const pageHTML = computed(() => entriesStore.pageHTML);
const entriesHTML = computed(() => entriesStore.entriesHTML);

// return page html code if refresh
watch(pageHTML, (newValue: string) => {
  if (newValue) emit("pageRefresh", newValue);
});

// livecycle - mounted
onMounted(() => {
  // init instance on state
  const hostNode = useHost() ?? getCurrentInstance()?.proxy?.$el;
  stateStore.addInstance(props.elemId, "entries", hostNode);
});

</script>
